import { RouteObject } from 'react-router-dom';
import { Experiences } from './Experiences';
import { EditExperience } from './EditExperience';

export const experiencesRoute: RouteObject = {
  path: 'experiences',
  children: [
    {
      index: true,
      element: <Experiences />,
    },
    {
      path: 'edit',
      element: <EditExperience />,
    },
  ],
};
